import * as Yup from "yup";

export const celebrationSchema = Yup.object().shape({
    name: Yup.string().required("This Field is required"),
    description: Yup.string().required("This Field is required"),
    time: Yup.string().required("This Field is required"),
    duration:Yup.number().max(5).required("This Field is required"),
});
 